// This file is generated.
export var version = '0.2.0';
//# sourceMappingURL=version.js.map